/* eslint-disable no-console */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { version, name } = require('../../package.json');
export const VERSION = `${name}:${version}`;
